module.exports = __webpack_public_path__ + "img/go.d42efe8f.png";